import { Component, computed, inject, viewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import {
  MaintenanceTimerDialogComponent,
} from '@pages/maintenance-timer-dashboard-page/maintenance-timer-dialog/maintenance-timer-dialog.component';
import {
  MaintenanceTimerDashboardListComponent,
} from '@pages/maintenance-timer-dashboard-page/maintenance-timer-dashboard-list/maintenance-timer-dashboard-list.component';
import {
  MaintenanceTimerDashboardFilterComponent,
} from '@pages/maintenance-timer-dashboard-page/maintenance-timer-dashboard-filter/maintenance-timer-dashboard-filter.component';
import {
  MaintenanceTimerDashboardFilterParams,
  parseFilterParams,
  sameQueryParams,
  toFilterDto,
  toQueryParams,
} from '@pages/maintenance-timer-dashboard-page/maintenance-timer-dashboard-filter-params';
import { isExternalTenant } from '@/utils/admin-utils';
import { queryParams } from '@/utils/signals/router';

@Component({
  standalone: false,
  selector: 'wr-maintenance-timer-dashboard-page',
  templateUrl: './maintenance-timer-dashboard-page.component.html',
  styleUrls: ['./maintenance-timer-dashboard-page.component.scss'],
})
export class MaintenanceTimerDashboardPageComponent {

  private readonly dialogService = inject(NbDialogService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly isExternalTenant = isExternalTenant();

  private readonly queryParams = queryParams();

  readonly filterParams = computed(() => parseFilterParams(this.queryParams()));

  readonly filter = computed(() => {
    const params = this.filterParams();
    return params ? toFilterDto(params, this.isExternalTenant()) : undefined;
  });

  readonly list = viewChild.required(MaintenanceTimerDashboardListComponent);
  readonly filterCard = viewChild.required(MaintenanceTimerDashboardFilterComponent);

  search(params: MaintenanceTimerDashboardFilterParams): void {
    const queryParams = toQueryParams(params);
    if (sameQueryParams(this.route.snapshot.queryParams, queryParams)) {
      this.list().refresh();
      return;
    }
    void this.router.navigate([], { relativeTo: this.route, queryParams, replaceUrl: true });
  }

  addMaintenanceTimer(buildingId?: string) {
    const ref = this.dialogService.open(MaintenanceTimerDialogComponent, {
      context: {
        buildingId,
      },
    });
    ref.componentRef.instance.save.subscribe(() => {
      if (this.filter()) {
        this.list().refresh();
        return;
      }
      this.search(this.filterCard().currentParams());
    });
  }
}
